import PromiseWorker from "promise-worker-transferable";
export class WebWorkerRunner {
    constructor(runnerId, fileName, devMode = false) {
        this.activeRunId = null;
        this.rawWorker = new Worker(fileName, { name: runnerId });
        this.worker = new PromiseWorker(this.rawWorker);
    }
    async handleRequest(req) {
        const resp = await this.worker.postMessage(req, []);
        this.activeRunId = resp.simulationRunId;
        return resp;
    }
    queueExperiment() {
        throw new Error("cannot queue experiments on a single web worker");
    }
}
//# sourceMappingURL=worker-runner.js.map